<main [style.--kendo-color-primary]="primaryColor">
    @if (minimized()) {
        <button class="chatbot-fab" (click)="minimized.set(false)" aria-label="Open Chatbot">
            <img src="chatbot.svg" alt="Avioblue Virtual Assistant Logo" />
        </button>
    } @else {
        <div class="chatbot-wrapper">
            <!--
                The domain is declared here rather than left to the `?domain=` query parameter, which
                used to resolve to this same value by default. A host declares its domain explicitly
                now, and the library refuses to guess one.
            -->
            <avioblue-chatbot domain="web" [showViewPicker]="false" [showAgentPicker]="false" (closeRequested)="minimized.set(true)"></avioblue-chatbot>
        </div>
    }
</main>
